/* global ga, afdDevice */
/**
 * This file contains the behaviour of old app/assets/javascripts/products.js
 */
import smoothscroll from 'smoothscroll-polyfill'
import { initAccordions, scrollToElement, requireCountryCode, sendAnalyticsEvent, removeQuoteFormByDevice, trackProductPageInteraction } from '../helpers/util'

smoothscroll.polyfill()

const interpolate = (template, values = {}) => {
  if (!template) return ''

  return template.replace(/%\{(\w+)\}/g, (_match, key) => values[key] || '')
}

/**
 * Avoiding a big gap in Product Singles 
 * when the product description is shorter than the quote form. 
 */
const handleSideBarStickyBox = () => {
  const mainContainer = document.getElementById('product-single')
  const contentContainerHeight = document.querySelector('.afd-main-content--left').getBoundingClientRect().height
  const sideBarContainerHeight = document.querySelector('.afd-main-sidebar--left').getBoundingClientRect().height
  const stickyForm = document.querySelector('.nft-sidebar-sticky')

  if (contentContainerHeight > (sideBarContainerHeight + stickyForm?.getBoundingClientRect().height)) {
    mainContainer.style.alignItems = 'stretch'
    stickyForm.style.position = 'sticky'
  }
}


const initGoToFormBtn = () => {
  const isPhone = afdDevice === 'phone'
  const fixedBtn = document.querySelector(isPhone ? '#js-single-mobile-quote' : '.js-goto-cotizar')
  const fixBtnWrapper = isPhone ? fixedBtn : document.getElementById('go-to-product-section')
  const form = document.getElementById(isPhone ? 'mobile-quote-form-react' : 'js-quote-form-react')
  let recaptchaBadge = document.querySelector('.grecaptcha-badge:not([data-style=none])')

  if (!form) return

  fixedBtn && fixedBtn.addEventListener('click', () => {
    scrollToElement(form, true, 16);
    const eventArgs = {
      type: 'event',
      category: 'quote-cta-on-mobile',
      action: 'click',
      label: 'Send message modal btn'
    }

    sendAnalyticsEvent(eventArgs);
  })

  // Show button only when form not visible
  const callback = entries => {
    recaptchaBadge = recaptchaBadge || document.querySelector('.grecaptcha-badge:not([data-style=none])')
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        fixBtnWrapper && fixBtnWrapper.classList.remove('show')
        isPhone && recaptchaBadge.classList.add('show')
      } else {
        fixBtnWrapper && fixBtnWrapper.classList.add('show')
        isPhone && recaptchaBadge.classList.remove('show')
      }
    })
  }
  const observer = new IntersectionObserver(callback, { threshold: isPhone ? [0.15, 0.85] : [0, 1] })
  observer.observe(form)
}

const initProductKeyboardNavigation = () => {
  document.addEventListener('keydown', e => {
    const { key, target: { tagName } = {} } = e
    const nextArrow = document.querySelector('.afd-article-navigation.afd-article-navigation--next')
    const prevArrow = document.querySelector('.afd-article-navigation.afd-article-navigation--prev')
    if (['input', 'select', 'textarea'].indexOf(tagName.toLowerCase()) >= 0) return true

    if (key === 'ArrowRight') {
      window.location.href = nextArrow?.href;
    } else if (key === 'ArrowLeft') {
      window.location.href = prevArrow?.href;
    }
  })
}

// Quote forms won't show if user is not in business countries
export const initQuoteForm = () => {
  const quoteForms = document.querySelectorAll('.js-single-quote-container')
  const modalQuoteForm = document.getElementById('modal-account-info-request')
  if (!quoteForms.length) return

  const { countries = '[]' } = quoteForms[0].dataset
  const parsedCountries = JSON.parse(countries)
  const currentCountry = parsedCountries.find(country => AFD.countryCode === country[1])
  const isUserInBusinessCountries = !!currentCountry

  initContactWidget(isUserInBusinessCountries)
  if (!isUserInBusinessCountries) {
    const comment = document.createComment(`Product not available in this country (${AFD.countryCode})`)
    quoteForms.forEach(form => {
      form.parentElement.append(comment)
      form.remove()
    })
    // remove single quote sticky widget
    const singleQuoteFormStickyWidget = document.getElementById('go-to-product-section')
    singleQuoteFormStickyWidget && singleQuoteFormStickyWidget.remove()
    return
  } else {
    modalQuoteForm?.remove()
    removeQuoteFormByDevice('.js-single-quote-container')
  }

  if (afdDevice === 'phone' && window['dataLayer'] && NFT.site === 'us') {
    window.dataLayer.push({ 'event': 'optimize.quote.form.mobile.activate' })
  }

  quoteForms.forEach(form => form.classList.remove('afd-hide'))
  showProductAvailableInCountryLabel(currentCountry[0])
  initQuoteFormCountryFieldCatalog()
  initGoToFormBtn()
}

const initContactWidget = isUserInBusinessCountries => {
  const device = window.innerWidth > 767 ? 'desktop' : 'mobile'
  const contactWidget = document.querySelector(`.js-nft-contact-widget.nft-contact-widget--${device}`)
  if (!contactWidget) return false

  const loader = contactWidget.querySelector('.js-contact-widget-loader')
  const sendMessageBtn = contactWidget.querySelector('.js-contact-widget-message')
  const phoneBtn = contactWidget.querySelector('.js-contact-widget-phone')
  const websiteBtn = contactWidget.querySelector('.js-contact-widget-browser')
  const shouldShowContactWidget = ((!!phoneBtn || !!websiteBtn) && isUserInBusinessCountries) || !isUserInBusinessCountries

  if (!shouldShowContactWidget) {
    contactWidget.remove()
    return false
  }
  contactWidget && (contactWidget.parentNode.style.position = 'sticky')
  initContactWidgetBtns([sendMessageBtn, phoneBtn, websiteBtn], !isUserInBusinessCountries)
  setUpStickyContactWidget(contactWidget, !isUserInBusinessCountries)

  const headerUserNotInCountry = contactWidget.querySelector('.js-header-in-country')
  const formQuoteHeader = contactWidget.querySelector('.js-company-profile')
  if (!formQuoteHeader || !headerUserNotInCountry) return false

  formQuoteHeader.classList.remove('afd-hide')
  headerUserNotInCountry.remove()
  loader && loader.remove()
}

const setUpStickyContactWidget = (widget, isNotOnBussinessCountry) => {
  const goToProductSection = document.getElementById('go-to-product-section')
  if (!goToProductSection) return false

  if (isNotOnBussinessCountry) {
    goToProductSection.parentElement.classList.add('sticky')
    return false
  }

  window.addEventListener('scroll', () => {
    if (goToProductSection.classList.contains('show')) {
      goToProductSection.style.order = 1
      widget.style.order = 2
    } else {
      goToProductSection.style.order = 2
      widget.style.order = 1
    }
  })
}

const openNewTab = url => {
  url && (window.open(url, 'new_tab'))
}

const initContactWidgetBtns = (buttons, showModalContact) => {
  const [sendMessageBtn, phoneBtn, websiteBtn] = buttons
  const eventArgs = {
    type: 'event',
    category: 'contact-widget-sticky',
    action: 'click'
  }

  if (sendMessageBtn && showModalContact) {
    sendMessageBtn.classList.remove('afd-hide')
    sendMessageBtn.addEventListener('click', () => {
      AFD.modals.open()
      sendAnalyticsEvent({ ...eventArgs, label: 'Open info quote request' })
    })
  }

  phoneBtn && phoneBtn.addEventListener('click', () => {
    const { href, phone } = phoneBtn.dataset
    const label = phoneBtn.querySelector('.data')
    trackProductPageInteraction('phone')
    sendAnalyticsEvent({ ...eventArgs, label: 'Phone button' })

    if (label.textContent !== phone) {
      label.textContent = phone
      return true
    }

    if (phoneBtn.href !== href) {
      phoneBtn.href = href
    }
  })

  websiteBtn && websiteBtn.addEventListener('click', () => {
    const { website } = websiteBtn.dataset
    trackProductPageInteraction('website', () => {
      let callbackCalled = false
      const finish = () => {
        if (callbackCalled) return
        callbackCalled = true
        openNewTab(website)
      }

      sendAnalyticsEvent({ ...eventArgs, label: 'Website button' }, finish)
      window.setTimeout(finish, 250)
    })
  })
}

const initProductPageInteractionTracking = () => {
  document.querySelectorAll('.js-toggle-popover[data-type="share"]').forEach(button => {
    button.addEventListener('click', () => trackProductPageInteraction('share'), true)
  })

  document.querySelectorAll('.afd-share__options .afd-entity').forEach(link => {
    link.addEventListener('click', event => {
      const href = link.getAttribute('href')
      const target = link.getAttribute('target')
      const platform = link.dataset.social || 'email'

      if (!href) return

      event.preventDefault()
      event.stopImmediatePropagation()

      trackProductPageInteraction('share', () => {
        if (target === '_blank') {
          window.open(href, '_blank', 'noopener')
        } else {
          window.location.assign(href)
        }
      }, platform)
    }, true)
  })

  document.querySelectorAll('.afd-share__options .js-copy-url').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault()
      event.stopImmediatePropagation()

      trackProductPageInteraction('share', () => afdCopyToClipboard(button), 'link copy')
    }, true)
  })

  document.querySelectorAll('.company-logo__link').forEach(link => {
    link.addEventListener('click', event => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) return

      event.preventDefault()

      const href = link.getAttribute('href')
      trackProductPageInteraction('brand-logo', () => {
        if (href) window.location.assign(href)
      })
    }, true)
  })
}


const showProductAvailableInCountryLabel = country => {
  const label = document.querySelector('.js-product-available-in')
  const countrySafe = country.normalize('NFD').replace(/[\u0300-\u036f\(\)']/g, '').replace(/[\/ /\,' ]+/g, '-').replace(/\./g, '').toLowerCase()
  if (!label || afdDevice !== 'desktop') return
  const countryLink = label.querySelector('a')
  countryLink.textContent = country
  countryLink.href = countryLink.href + countrySafe + '?ad_source=neufert&ad_medium=product_available_link'
  label.classList.remove('afd-hide')
}

const initQuoteFormCountryFieldCatalog = () => {
  var currentUri = window.location.pathname
  if (currentUri.includes('catalog/' + AD.site + '/products') && AFD.countryCode !== undefined) {
    window.dispatchEvent(new CustomEvent('afd:initCountryCode', { detail: AFD.countryCode }))
  }
}

const addSaveFolder = (img, index, link) => afdGetTemplateInstance('save-image-folder', { bookmark: { 'data-image': img.src, 'data-title': `${document.title} - ${index}`, href: link } })

// Adding Gallery Link and Save folder on Product Images.
const addSaveFolderToImages = () => {
  const images = document.querySelectorAll('.single-content-text[itemprop="description"] img');

  images && images.forEach((img, index) => {
    const link = img.parentNode.href
    const container = img.closest('.product-image__container')
    container && container.appendChild(addSaveFolder(img, index, link))
  })
}

export const optimizeGalleryImagesAtBottom = () => {
  const hasGalleryImagesAtBottom = document.querySelectorAll('#product-single .nft-minis.clearfix')[1]
  hasGalleryImagesAtBottom && window['dataLayer'] && window.dataLayer.push({ 'event': 'optimize.gallery.images.at.bottom' })
}

const showHiddenFiles = () => {
  const hiddenDownloadFiles = document.querySelectorAll('.nft-files-list__item.js-download-file-item.afd-hide')
  hiddenDownloadFiles && hiddenDownloadFiles.forEach(hiddenFile => hiddenFile.classList.remove('afd-hide'))
}

export const seeMoreDownloadFiles = () => {
  const seeMoreButton = document.querySelector('.js-see-more-files')

  seeMoreButton && seeMoreButton.addEventListener('click', () => {
    seeMoreButton.classList.add('afd-hide')
    showHiddenFiles()
  })
}

const productAvailabilityVariant = props => {
  const countryCode = window.AFD && window.AFD.countryCode

  if (!countryCode) return props.langMismatch ? props.copy.langMismatch : null

  const businessCountries = props.businessCountries || []
  const location = (window.NFT && window.NFT.countries && window.NFT.countries[countryCode]) || countryCode
  const userInBusinessCountries = businessCountries.includes(countryCode)

  if (userInBusinessCountries) {
    return props.langMismatch ? props.copy.langMismatch : null
  }

  if (props.langMismatch) {
    return props.copy.langMismatchGeoNoSibling
  }

  return {
    heading: interpolate(props.copy.geoNoSibling.heading, { location })
  }
}

export const initProductAvailabilityToaster = () => {
  const toasterWrappers = Array.from(document.querySelectorAll('.js-product-availability-toaster'))
  if (!toasterWrappers.length) return

  const activeDevice = afdDevice === 'phone' ? 'mobile' : 'desktop'
  const matchingWrappers = toasterWrappers.filter(wrapper => wrapper.dataset.device === activeDevice)
  const wrappersToUse = matchingWrappers.length ? matchingWrappers : [toasterWrappers[0]]
  const wrappersToHide = toasterWrappers.filter(wrapper => !wrappersToUse.includes(wrapper))

  wrappersToHide.forEach(wrapper => wrapper.remove())

  const renderToaster = () => {
    wrappersToUse.forEach(toasterWrapper => {
      const toaster = toasterWrapper.querySelector('hd-toaster')
      if (!toaster) return

      const props = JSON.parse(toasterWrapper.dataset.props || '{}')
      const variant = productAvailabilityVariant(props)

      if (!variant || !variant.heading) {
        toaster.removeAttribute('heading')
        toaster.removeAttribute('message-html')
        toasterWrapper.classList.add('afd-hide')
        return
      }

      toaster.setAttribute('heading', variant.heading)

      if (variant.message) {
        toaster.setAttribute('message-html', variant.message)
      } else {
        toaster.removeAttribute('message-html')
      }

      toasterWrapper.classList.remove('afd-hide')
    })
  }

  renderToaster()
  requireCountryCode(renderToaster)
}

export const initProductPage = async () => {
  requireCountryCode(initQuoteForm)
  initProductKeyboardNavigation()
  initProductPageInteractionTracking()
  initAccordions()
  addSaveFolderToImages()
  afdDevice !== 'phone' && handleSideBarStickyBox()
}
